import type { GameId } from '../api/types';
import type { ScannedTicket } from '../hooks/scannedTicketUtils';

const LOCAL_PREVIEW_TICKET_COUNT = 12;

export function withLocalTicketPreviewMocks(
  tickets: ScannedTicket[],
  gameId: GameId
): ScannedTicket[] {
  if (!isLocalTicketPreviewEnabled()) return tickets;
  if (tickets.length === 0 || tickets.length >= LOCAL_PREVIEW_TICKET_COUNT) return tickets;

  const mocksNeeded = LOCAL_PREVIEW_TICKET_COUNT - tickets.length;
  const mockTickets = Array.from({ length: mocksNeeded }, (_, index) =>
    makeLocalPreviewTicket(gameId, index + 1)
  );
  return [...tickets, ...mockTickets];
}

function isLocalTicketPreviewEnabled(): boolean {
  if (process.env.REACT_APP_ENABLE_LOCAL_TICKET_MOCKS === 'true') return true;
  if (process.env.NODE_ENV !== 'development') return false;
  if (typeof window === 'undefined') return false;

  const host = window.location.hostname.toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '[::1]';
}

function makeLocalPreviewTicket(gameId: GameId, index: number): ScannedTicket {
  const seed = index * 7 + (gameId === 'powerball' ? 3 : 11);
  const mainRange = gameId === 'powerball' ? 69 : 70;
  const bonusRange = gameId === 'powerball' ? 26 : 25;
  const main = Array.from({ length: 5 }, (_, pos) => ((seed + pos * 8) % mainRange) + 1).sort(
    (a, b) => a - b
  );
  const bonus = [((seed * 3) % bonusRange) + 1];
  const status = localPreviewStatus(index);
  const match = status === 'won-small' ? { main: main.slice(0, 2), bonus: [] } : undefined;

  return {
    id: `lp${String(index).padStart(4, '0')}`,
    gameId,
    main,
    bonus,
    drawDate: localPreviewDrawDate(index),
    status,
    prize: status === 'won-small' ? 4 : undefined,
    scannedAt: `2026-05-${String(Math.max(1, 31 - index)).padStart(2, '0')}T12:00:00Z`,
    source: 'ocr',
    confidence: 0.91 - (index % 5) * 0.02,
    match,
  };
}

function localPreviewStatus(index: number): ScannedTicket['status'] {
  if (index % 5 === 0) return 'won-small';
  if (index % 3 === 0) return 'pending';
  return 'lost';
}

function localPreviewDrawDate(index: number): string {
  const drawDays = [31, 28, 26, 24, 21, 19, 17, 14, 12, 10, 7, 5];
  const day = drawDays[(index - 1) % drawDays.length];
  return `2026-05-${String(day).padStart(2, '0')}`;
}
